import { render, staticRenderFns } from "./LoginIssue.vue?vue&type=template&id=118987fd&"
import script from "./LoginIssue.vue?vue&type=script&lang=js&"
export * from "./LoginIssue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports